import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./companyInfo.scss";
import Button from "../Button";
import { useHistory } from "react-router-dom";
import {
  Box,
  makeStyles,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Input,
  InputLabel,
  FormHelperText
} from "@material-ui/core";
import { setTaxes } from "../../redux/taxesData";

const useStyles = makeStyles(theme => ({
  container: {
    borderTop: "2px solid #cfdae2",
    position: "relative",
    marginTop: 8,
    marginBottom: 16,
    [theme.breakpoints.up("md")]: {
      marginTop: 30
    }
  },
  title: {
    fontSize: "16px",
    color: "#004987",
    margin: "-20px",
    padding: "0 10px",
    backgroundColor: "#fff",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px"
    }
  },
  legendIcon: {
    backgroundColor: "white",
    width: 38,
    height: 38,
    border: "2px solid lightgrey",
    borderRadius: "50%",
    display: "none",
    justifyContent: "center",
    alignItems: "center",
    color: "lightgrey",
    position: "absolute",
    right: 30,
    top: -19,
    [theme.breakpoints.up("sm")]: {
      display: "flex"
    }
  },
  formControl: {
    padding: "24px",
    flex: 1,
    marginLeft: "20px",
    marginRight: "20px",
    width: "100%"
  },
  error: {
    color: "#FF0000"
  }
}));

export default function CompanyInfo(props) {
  const history = useHistory();
  const classes = useStyles();
  const [cuit, setCuit] = useState();
  const [condition, setCondition] = useState();
  const [condition2, setCondition2] = useState();
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const { user } = useSelector(({ user }) => ({
    user
  }));

  function handleClick() {
    setCuit(user.numeroDocumento);
    if (condition && condition2) {      
      dispatch(setTaxes({ condition, cuit, condition2 }));
      history.push("/domicilio/nuevo");
    } else {
      setError("Falta información obligatoria");
    }
  }

  return (
    <div className="declaration-container">
      <Box classes={{ root: classes.container }}>
        <Box classes={{ root: classes.legendIcon }}>
          <img
            src={require("../../img/pencil.svg")}
            alt=""
            style={{ width: "50%" }}
          />
        </Box>
      </Box>

      <FormControl classes={{ root: classes.formControl }}>
        <InputLabel
          shrink
          focused={false}
          htmlFor="cuit"
          classes={{ root: classes.label }}
        >
          CUIT
        </InputLabel>
        <Input
          id="cuit"
          name="cuit"
          readOnly={true}
          value={user.numeroDocumento}
          classes={{ root: classes.input }}
        />
      </FormControl>
      <FormControl classes={{ root: classes.formControl }}>
        <InputLabel
          shrink
          focused={false}
          htmlFor="taxes"
          classes={{ root: classes.label }}
        >
          Condición frente al IVA
        </InputLabel>
        <RadioGroup name="taxes" classes={{ root: classes.input }}>
          <FormControlLabel
            value="MONO"
            control={<Radio />}
            label="Contribuyente Régimen Simplificado"
            onChange={e => setCondition(e.target.value)}
          />
          <FormControlLabel
            value="INSC"
            control={<Radio />}
            label="Responsable inscripto"
            onChange={e => setCondition(e.target.value)}
          />
        </RadioGroup>
        <FormHelperText classes={{ root: classes.error }}>
          {error}
        </FormHelperText>
      </FormControl>
      <FormControl classes={{ root: classes.formControl }}>
        <InputLabel
          shrink
          focused={false}
          htmlFor="taxes-prov"
          classes={{ root: classes.label }}
        >
          Ingresos Brutos
        </InputLabel>
        <RadioGroup name="taxes-prov" classes={{ root: classes.input }}>
          <FormControlLabel
            value="S"
            control={<Radio />}
            label="Si"
            onChange={e => setCondition2(e.target.value)}
          />
          <FormControlLabel
            value="N"
            control={<Radio />}
            label="No"
            onChange={e => setCondition2(e.target.value)}
          />
        </RadioGroup> 
        <FormHelperText classes={{ root: classes.error }}>
          {error}
        </FormHelperText>
      </FormControl>

      <div className="button-container">
        <Button color="primary" onClick={() => props.closeModal(false)}>
          Volver
        </Button>
        <Button color="secondary" onClick={() => handleClick()}>
          Continuar
        </Button>
      </div>
    </div>
  );
}
